export default {
  namespaced: true,
  video_wall: {
    assign_a_video_wall:"Asignar a videoWall",
    video_wall_users: "Usuarios video wall",
    no_view_assigned: "sin vista asignada",
  },
};
